import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="pg">
      <div className="panel empty" style={{ maxWidth: "32rem", margin: "3rem auto" }}>
        <i className="fas fa-compass" />
        <h1 style={{ fontSize: "1.25rem", color: "var(--ink)", margin: "0 0 .4rem" }}>Page not found</h1>
        <p style={{ margin: "0 0 1.2rem" }}>This address doesn't match any page in the menu.</p>
        <Link to="/dashboard" className="btn primary">Go to the dashboard</Link>
      </div>
    </main>
  );
}
